"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _toConsumableArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  line-height: 47px !important;\n  width: auto;\n  float: left;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex !important;\n  flex-direction: row !important;\n  justify-content: ", " !important;\n\n  .label {\n    margin-right: 15px;\n  }\n\n  .options {\n    display: flex;\n    flex-wrap: wrap;\n    margin-left: 20px;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column !important;\n\n    .label {\n      display: none;\n    }\n\n    .options {\n      margin: 0;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var option_1 = __importDefault(require("./option"));

var core_1 = require("@material-ui/core");

var MyOptionGroup = function MyOptionGroup(props) {
  var name = props.name,
      selectedValue = props.selectedValue,
      onChange = props.onChange,
      selectedColor = props.selectedColor,
      simple = props.simple,
      all = props.all,
      label = props.label,
      style = props.style,
      options = props.options,
      compact = props.compact;

  var renderOptions = function renderOptions(options) {
    return options.map(function (option, idx) {
      var value = typeof option.value === 'boolean' ? option.value : option.value || option.id;
      var checked = selectedValue === value;

      var id = option.id,
          restOption = __rest(option, ["id"]);

      return react_1.default.createElement(option_1.default, Object.assign({
        key: "".concat(name, "-option-").concat(idx),
        selected: checked,
        onChange: onChange,
        selectedColor: selectedColor && checked ? selectedColor : 'black',
        id: "my-option-".concat(id)
      }, restOption, {
        name: name,
        value: value,
        label: option.label || option.name,
        simple: simple || false
      }));
    });
  };

  var myOptions = all ? [{
    id: 0,
    name: 'All'
  }].concat(_toConsumableArray(options)) : options;
  return react_1.default.createElement(StyledFormControl, {
    compact: compact ? 'compact' : undefined,
    style: style
  }, label && react_1.default.createElement(StyledFormLabel, {
    className: "label"
  }, label), react_1.default.createElement("div", {
    className: "options"
  }, renderOptions(myOptions)));
};

var StyledFormControl = styled_components_1.default(core_1.FormControl)(_templateObject(), function (props) {
  return props.compact ? 'flex-start' : 'space-between';
});
var StyledFormLabel = styled_components_1.default(core_1.FormLabel)(_templateObject2());
exports.default = MyOptionGroup;